module.exports = __webpack_public_path__ + "static/media/box-check.22c12134.svg";